const dev = {  	
	

	//    API_ENDPOINT_URL:  'https://gendialerqa.voiceracx.ai/vdl/',
	//    API_ENDPOINT_URL: 'http://localhost:1010/vdl/',
	//    API_ENDPOINT_URL:  'https://gendialer.voiceracx.ai/vdl/',
	       API_ENDPOINT_URL: 'https://gendialerqa.voiceracx.ai/vdl/',

	   AI_API_URL: 'https://vlmmini.voicera-analytics.com/',
	   VLM_UI_URL: 'https://vlmui.voiceracx.ai',

}

const prod = {
	
	 API_ENDPOINT_URL:  'https://gendialerqa.voiceracx.ai/vdl/',
	// API_ENDPOINT_URL: 'https://nezda.voiceracx.ai/vdl/',
	// API_ENDPOINT_URL: 'http://localhost:1010/vdl/',
	
    

	   AI_API_URL: 'https://vlmmini.voicera-analytics.com/',
	   VLM_UI_URL: 'https://vlmui.voiceracx.ai',
	
	
};

const test = {
	// API_ENDPOINT_URL: 'https://vdlprd-hzeagea4cphyd5dn.eastus-01.azurewebsites.net/vdl/',
	// API_ENDPOINT_URL: 'https://vdlqa-c4eaa4exd9byatg7.eastus-01.azurewebsites.net/vdl/',
	   API_ENDPOINT_URL: 'https://gendialer.api.voiceracx.ai/vdl/',

	   AI_API_URL: 'https://vlmmini.voicera-analytics.com/',
	   VLM_UI_URL: 'https://vlmui.voiceracx.ai'
	
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
